<template>
    <div>
        <div class="row h1 page-header">
            Products
            <button class="btn btn-primary pull-right" @click="showForm" v-show="!addMode">Add New Product</button>
            <button class="btn btn-danger pull-right" @click="hideForm" v-show="addMode">Cancel</button>
        </div>

        <product-form v-if="addMode" @changed="reloadProducts()" :current="current"></product-form>

        <products-list ref="productsList" @edit="edit($event)"></products-list>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                addMode: false,
                current: null
            }
        },

        methods: {
            showForm() {
                this.addMode = true;
            },

            hideForm() {
                this.addMode = false;
                this.current = null;
            },

            reloadProducts() {
                this.addMode = false;
                this.current = null;
                this.$refs.productsList.getProducts();
            },

            edit(event) {
                this.addMode = true;
                this.current = event;
            }
        }
    }
</script>
